module.exports = __webpack_public_path__ + "img/Nordeste.4e0bf431.svg";